module.exports = __webpack_public_path__ + "img/tees.bb135223.svg";